export const API_URL = "https://api.tylt.money";
export const API_KEY_EURO = "2410fad7fc8be2ca3accd60141f8beb9b32a87afed870289";
export const API_SECRET_EURO =
  "a71e0d76221058afd938fbdf8d66dcc19a9b7ed54a278de8a6be171c53fb9f5b";
export const API_KEY_CAD = "d5bf8dbe4810a67f1a53a4b17c7a9e19781852b94033faf4";
export const API_SECRET_CAD =
  "0c93cb228b3f350b2cba2dd1c815d781229b295e39e78f49889b872881eec877";
export const API_KEY_EURO_PAYOUT =
  "e73ef428fe0803cbf5ffb64c6befcd8a51cf55c68d4429c6";
export const API_SECRET_EURO_PAYOUT =
  "b381ca265be80e7ab266ab047546156dc8bd1f12703dd2a5523372b95ce48e44";
export const API_KEY_CAD_PAYOUT =
  "7d42c7169517d58c03fba1615e2659caa5ee7f80efd6fe68";
export const API_SECRET_CAD_PAYOUT =
  "133dd3a3efe21c48d57759f12506e781cae8db811e5b5a8b101391efd30d0abe";
export const WS_BASE_URL = "wss://ws.tylt.money";
export const REDIRECT_URL =
  typeof window !== "undefined" ? window.location.origin : "";
export const CALLBACK_URL =
  typeof window !== "undefined" ? window.location.origin : "";
